
export const convertToCSV = (objArray: any[]) => {
  const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;

  const convertValue = (value: any): string => {
    if (value === null) {
      return "null";
    }
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }
    return value.toString();
  };

  let str = `${Object.keys(array[0]).map(key => `"${key}"`).join(",")}\r\n`;
  return array.reduce((str: string, next: any) => {
    str += `${Object.values(next).map(value => `"${convertValue(value)}"`).join(",")}\r\n`;
    return str;
  }, str);
};

export const handleDownloadAll = async (data: any[], filename: string) => {
  const csvData = convertToCSV(data);
  const blob = new Blob([csvData], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${filename}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const handleDownloadAllJson = async (data: any[], filename: string) => {
  const jsonData = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonData], { type: 'application/json' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${filename}.json`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const handleJsonImport = <T,>(onData: (data: T) => void) => {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.json';

  input.onchange = (event: Event) => {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      const file = target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const text = e.target?.result as string;
          const data = JSON.parse(text) as T;
          onData(data);
        } catch (err) {
          console.error('JSON import error:', err);
        }
      };
      reader.readAsText(file);
    }
  };
  input.click();
};